<template>
  <div v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_property')">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(pagetitle) }}</h3>
      </div>

      <form class="form-horizontal">
        <div class="box-body">
          <div class="form-group required">
            <label for="name" class="col-sm-2 control-label">{{
              $t("property.name")
            }}</label>
            <div class="col-sm-10">
              <input
                v-model="propertydata.name"
                type="text"
                class="form-control"
                id="name"
                :placeholder="$t('property.asset.name')"
                @input="validateNameAsset"
              />
              <span v-if="nameIsNull == false" class="help is-danger">
                <font color="red">{{ $t(error_msg.nameSmg) }}</font>
              </span>
            </div>
          </div>

          <div class="form-group required">
            <label for="name" class="col-sm-2 control-label">{{
              $t("property.type_name")
            }}</label>
            <div class="col-sm-10">
              <select
                @change="validateTypeAsset"
                :disabled="disablePropertys"
                v-model="propertydata.type"
                class="form-control"
              >
                <option
                  v-for="(property, index) in propertys"
                  v-bind:value="property.value"
                  :key="property.value"
                  >{{ index == 0 ? $t(property.text) : property.text }}</option
                >
              </select>
              <span v-if="typeIsNull == false" class="help is-danger">
                <font color="red">{{ $t(error_msg.typeSmg) }}</font>
              </span>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">{{
              $t("property.apartment_code")
            }}</label>
            <div class="col-sm-10">
              <input
                v-model="propertydata.apartment_code"
                type="text"
                class="form-control"
                :disabled="true"
                :placeholder="$t('property.apartment_code')"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-2 control-label">{{
              $t("property.amount")
            }}</label>
            <div class="col-sm-10">
              <input
                v-model="propertydata.amount"
                type="text"
                class="form-control"
                :disabled="true"
                :placeholder="$t('property.amount')"
              />
            </div>
          </div>

          <div class="form-group" v-show="show">
            <label for="name" class="col-sm-2 control-label">{{
              $t("property.qrcode")
            }}</label>
            <div class="col-sm-10">
              <img
                :src="imageSrc"
                alt="QR code"
                width="232"
                style="width: 232px;"
                sizes="(max-width: 232px) 100vw, 232px"
              />

              <div
                class="row text-center"
                style="border:0px solid red;width:252px;"
              >
                <h3 class="panel-title">
                  <strong>{{ propertydata.name }}</strong>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="box-footer">
          <button
            type="button"
            class="btn btn-labeled btn-danger"
            @click="CancelPropertyList"
            style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          >
            <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
            {{ $t("common.back") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-success pull-right"
            @click="SavePropertyList"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{ $t("common.save") }}
          </button>
          <button
            type="button"
            class="btn btn-labeled btn-warning pull-right"
            @click="printPdf"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-print"></i>
            </span>
            {{ $t("common.printPdf") }}
          </button>
        </div>
      </form>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <router-view></router-view>
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import config from "../../../build/config"
import utils from '@/lib/utils'

export default {
  name: "PropertyAdd",
  data() {
    return {
      actionType: "",
      timeCurrent: "2019-01-16T06:00:00Z",
      propertys: [{ text: "property.selectOne", value: null }],
      propertySelected: null,
      apartments: [{ text: "property.selectOne", value: null }],
      apartmentSelected: null,
      pagetitle: "property.asset.new_asset_page",
      noqrcode: "noqrcode.png",
      show: false,
      propertydata: {
        id: 0,
        name: "",
        type: 1,
        apartment: 0,
        apartment_code: "",
        price: 0,
        price_depreciation: 0,
        amount: 0
      },
      disablePropertys: false,
      disableApartments: false,
      nameIsNull: true,
      typeIsNull: true,
      codeApartmentIsNull: true,
      error_msg: {
        nameSmg: "",
        typeSmg: "",
        codeApartmentSmg: ""
      }
    };
  },

  watch: {
    // watch customer detail
    PROPERTY_DETAIL_DATA: function() {
      this.propertydata.name = this.PROPERTY_DETAIL_DATA.name;
      this.propertydata.type = this.PROPERTY_DETAIL_DATA.property_type;
      this.propertydata.price = this.PROPERTY_DETAIL_DATA.price;
      this.propertydata.price_depreciation = this.PROPERTY_DETAIL_DATA.price_depreciation;
      this.propertydata.apartment = this.PROPERTY_DETAIL_DATA.apartment;
      this.propertydata.apartment_code = this.PROPERTY_DETAIL_DATA
        .apartment_details
        ? this.PROPERTY_DETAIL_DATA.apartment_details.apt_code
        : null;
      this.propertydata.amount = this.PROPERTY_DETAIL_DATA.amount;
    }
  },
  computed: {
    imageSrc: function() {
      let qrcode = this.noqrcode;
      var url = "/media/QRCode/";
      if (this.propertydata.id != 0) {
        qrcode = this.propertydata.id + ".png";
        url += "property/";
      }

      let backendURL = config.BACKEND_URL;
      return backendURL + url + qrcode;
    },
    ...mapGetters([
      "GET_SNACK_BAR",
      "PROPERTY_DETAIL_DATA",
      "GET_ACCOUNT_DATA",
      "GET_PROPERTY_TYPE_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ADD_PROPERTY",
      "GET_PROPERTY_DETAIL",
      "UPDATE_PROPERTY",
      "GET_PROPERTY_TYPE_LIST",
      // "GET_APARTMENT_LIST"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getSelectedItemType: function(newObjectState, objectId) {
      // Just a regular js function that takes 2 args
      //console.log(newObjectState + " --- " + objectId);
      //console.log(JSON.stringify(this.apartments))
    },

    CancelPropertyList: function() {
      // 7. When clicking on "Hủy" button of device detail
      if (typeof this.$route.query.apartment_id == "undefined") {
        this.$router.push({
          name: "PropertyList"
        });
      } else {
        this.$router.push({
          name: "ApartmentAdd",
          params: {
            id: this.propertydata.apartment
          }
        });
      }
    },
    printPdf: function() {
      let routeData = this.$router.resolve({
        name: "PropertyPdf",
        params: {
          id: this.propertydata.id
        }
      });
      window.open(routeData.href, "_blank");
    },
    validateNameAsset: function() {
      this.error_msg.nameSmg = "";
      this.nameIsNull = true;
      if (this.propertydata.name == null || this.propertydata.name == "") {
        this.error_msg.nameSmg = "common.error_msg[0].required";
        this.nameIsNull = false;
      }
      return this.nameIsNull;
    },
    validateTypeAsset: function() {
      this.error_msg.typeSmg = "";
      this.typeIsNull = true;
      if (this.propertydata.type == null) {
        this.error_msg.typeSmg = "common.error_msg[0].required";
        this.typeIsNull = false;
      }
      return this.typeIsNull;
    },
    validateApartmentAsset: function() {
      this.error_msg.codeApartmentSmg = "";
      this.codeApartmentIsNull = true;
      if (this.propertydata.apartment == null) {
        this.error_msg.codeApartmentSmg = "common.error_msg[0].required";
        this.codeApartmentIsNull = false;
      }
      return this.codeApartmentIsNull;
    },
    checkForm: function() {
      let checkName = this.validateNameAsset();
      let checkType = this.validateTypeAsset();
      let checkApartment = this.validateApartmentAsset();

      if (checkName && checkType && checkApartment) {
        return true;
      } else {
        return false;
      }
    },
    SavePropertyList: function(event) {
      let result = this.checkForm();
      if (result) {
        let data = {
          name: this.propertydata.name,
          price: this.propertydata.price,
          price_depreciation: this.propertydata.price_depreciation,
          property_type: this.propertydata.type,
          id: this.propertydata.id,
          apartment_id: this.propertydata.apartment,
          amount: this.propertydata.amount
        };
        if (parseInt(this.propertydata.id) == 0) {
          this.ADD_PROPERTY(data)
            .then(
              function() {
                // this.$router.push({ name: "PropertyList" });
                this.SUCCESS_TOAST();
                // 3. When creating device, click on save will navigate back to apartment info
                this.$router.push({
                  name: "ApartmentAdd",
                  params: {
                    id: this.propertydata.apartment
                  }
                });
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_PROPERTY(data)
            .then(
              function() {
                if (typeof this.$route.query.apartment_id == "undefined") {
                  this.$router.push({ name: "PropertyList" });
                } else {
                  this.$router.push({
                    name: "ApartmentAdd",
                    params: {
                      id: this.$route.query.apartment_id
                    }
                  });
                }
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        }
      }
    }
  },
  mounted() {
    let id = this.$route.params.id;

    if (parseInt(id) !== 0) {
      this.propertydata.id = id;
      this.pagetitle = "property.editProperty";
      this.GET_PROPERTY_DETAIL({ id: id });
      this.show = true;

      // 5. Type is not disable. Expected: disable
      this.disablePropertys = true;
      // 6. Apartment info is empty. Expected: show apartment info here
      this.propertydata.apartment = this.$route.query.apartment_id;
      this.disableApartments = true;
    } else {
      //
      this.pagetitle = "property.addNewProperty";
      let property_type_enable = this.$route.params.property_type_enable;
      let apartment_enable = this.$route.params.apartment_enable;

      this.propertydata.type = this.$route.params.property_type_id;
      // this.propertydata.servicetype = this.$route.params.property_service_type;

      this.propertydata.apartment = this.$route.params.apartment_id;
      // console.log("Create with apartment : " + this.propertydata.apartment)

      this.disablePropertys = property_type_enable;
      this.disableApartments = apartment_enable;

      this.disablePropertys = property_type_enable;
      this.disableApartments = apartment_enable;
    }

    this.GET_PROPERTY_TYPE_LIST().then(
      function(res) {
        let result = res.data;
        result.results.forEach(v => {
          let data = {
            text: v.name,
            value: v.id
          };
          this.propertys.push(data);
        });
      }.bind(this)
    );
  },
  components: {
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
</style>



// WEBPACK FOOTER //
// src/views/Property/PropertyAdd.vue